import React from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../../store/applicationState';
import { TestPass } from './TestPass';
import { TestReview } from './TestReview';

export const Test: React.FC = () => {
  const [isTest, setIsTest] = React.useState(false);
  const [isReview, setIsReview] = React.useState(false);
  const { Sockets, FinalTest } = useSelector((store: AppStore) => store);

  const { room } = Sockets;

  React.useEffect(() => {
    if (FinalTest.data && FinalTest.data.myAnswers?.length !== 0) {
      setIsReview(true);
    }
  }, [FinalTest.data]);

  const renderBody = () => {
    if (Sockets.event && isReview && FinalTest.data) {
      return (
        <TestReview isTest={isTest} typeId={Sockets.event.type_id} groupId={Sockets.event.group_id} test={FinalTest.data} onReview={setIsReview} />
      );
    }
    if (!isReview && FinalTest.data && room) {
      return (
        <TestPass
          test={FinalTest.data}
          room={room}
          handleSend={() => {
            setIsReview(true);
            setIsTest(true);
          }}
          error={FinalTest.error}
        />
      );
    }
    return null;
  };

  return <div>{renderBody()}</div>;
};
